import clsx from "clsx";

import { Icon } from "~/assets/icons/Icon";

import styles from "./WidgetErrorView.module.scss";

export const WidgetErrorView = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={clsx(styles.root, className)}>
      <Icon iconName="DangerIcon" width="2rem" height="2rem" />
      <p>{children}</p>
    </div>
  );
};
